export const CORE_USER_PERMISSIONS = {
    // NEW
    // Accounts
    VIEW_ALL_ACCOUNTS: 'view_all_accounts',
    MANAGE_ACCOUNTS: 'manage_accounts',
    CREATE_ACCOUNTS: 'create_accounts',
    UPDATE_ACCOUNTS: 'update_accounts',
    DELETE_ACCOUNTS: 'delete_accounts',
    CLEANUP_EMAILS: 'cleanup_emails',
    CHANGE_ACCOUNTS_PASSWORD: 'change_accounts_password',
    MANAGE_AUTO_FILTERS: 'manage_auto_filters',

    // Addressbooks
    MANAGE_ADDRESSBOOKS: 'manage_addressbooks',

    // Companies
    VIEW_ALL_COMPANIES: 'view_all_companies',
    MANAGE_COMPANIES: 'manage_companies',
    CREATE_COMPANIES: 'create_companies',
    UPDATE_COMPANIES: 'update_companies',
    DELETE_COMPANIES: 'delete_companies',

    // Contacts
    MANAGE_CONTACTS: 'manage_contacts',

    // Groups
    VIEW_ALL_GROUPS: 'view_all_groups',
    MANAGE_GROUPS: 'manage_groups',

    // Logs
    VIEW_LOGS: 'view_logs',

    // Messages
    VIEW_ALL_MESSAGES: 'view_all_messages',
    HANDLE_MESSAGES: 'handle_messages',
    ASSIGN_MESSAGES: 'assign_messages',
    WRITE_MESSAGES: 'write_messages',
    TRASH_MESSAGES: 'trash_messages',
    DOWNLOAD_MESSAGES: 'download_messages',
    PROTOCOL_MESSAGES: 'protocol_messages',
    SEND_MESSAGES: 'send_messages',

    // OAuthApps
    MANAGE_OAUTHAPPS: 'manage_oauthapps',

    // Tags
    MANAGE_TAGS: 'manage_tags',

    // TrashBin
    CLEANUP_TRASHBIN: 'cleanup_trashbin',

    // Users
    VIEW_ALL_USERS: 'view_all_users',
    MANAGE_USERS: 'manage_users',
    CREATE_USERS: 'create_users',
    UPDATE_USERS: 'update_users',
    DELETE_USERS: 'delete_users',

    // Retention
    MANAGE_RETENTION: 'manage_retention',

    // LEGACY
    LEGACY_VIEW_MAILS: 'view_mails',
    LEGACY_SEND_MAILS: 'send_mails',
    LEGACY_VIEW_ALL_MAILS: 'view_all_mails',
    LEGACY_TAG_MESSAGES: 'tag_messages',
    LEGACY_EDIT_MESSAGES_STATUS: 'edit_messages_status',
    LEGACY_EDIT_ACCOUNTS_PASSWORD: 'edit_accounts_password',
    LEGACY_EDIT_COMPANIES: 'edit_companies',
    LEGACY_EDIT_ACCOUNTS: 'edit_accounts',
    LEGACY_EDIT_USERS: 'edit_users',
}
